import { IEntity } from "./ientity";
import { IPublishable } from "./ipublishable";

export interface IDashboard extends IEntity {
    heading: string;
    dropDowns: IDropDown[];
}

export interface IDropDown extends IEntity {
    label: string;
    dropDownItems: IDropDownItem[];
    parentDropDownItemId: number;
    parentDashboardDropDownId: number;
    countryDescriptions: ICountryDescription[];
    selectedDropDownItem: IDropDownItem;
    presentationTypeId: number;
}

export interface IDropDownItem extends IEntity {
    text: string;
    colour: string;
}

export interface ICountryDescription extends IEntity, IPublishable {
    countryId: number;
    countryCode: string;
    dropDownItemId: number;
    dashboardDropdownId: number;
    dropdDownId: number;
    text: string;
    countryName: string;
}

export class CountryDashboardInformationItem  {
    countryDescription: ICountryDescription;
    keyDropDown: IDropDown;
    itemLabel: string;
}

export class CountryDashboardInformation {
    constructor() {
        this.dropDownsToRender = new Array();
        this.items = new Array();
    }
    countryId: number;
    countryName: string;
    countryCode: string;
    items: CountryDashboardInformationItem[];
    parentOfKeyDropDown: IDropDown;
    dropDownsToRender: IDropDown[];
    selectedItemIndex: number;
}

